export enum SupportStatus {
  open = 'OPEN',
  inProgress = 'IN_PROGRESS',
  resolved = 'RESOLVED',
  closed = 'CLOSED',
}